import { useContext } from "react";
import { LanguageContext } from "./multilingualContext";
import { translations } from "./translations";

/**
 * Utility function to generate text dependant on the language
 * @param {React Component props} props destructured just for the contentID
 * @returns
 */
export default function MultiLingualContent({ contentID }) {
    const { language } = useContext(LanguageContext);

    return translations[language][contentID];
}

export function getText(contentID, language) {
    if (!contentID) return "";
    const lang = language || process.env.REACT_APP_LANG;
    const entry = translations?.[lang]?.[contentID];
    if (entry !== undefined && entry !== null) return entry;
    // fallback: try to find the key in any language
    for (const l of Object.keys(translations || {})) {
        const v = translations[l]?.[contentID];
        if (v !== undefined && v !== null) return v;
    }
    return "";
}